<script setup lang="ts">
const route = useRoute();
const { t } = useI18n();

useHead({ titleTemplate: (title) => t("settings.layout.titleTemplate", { title }) });

const ui = {
  main: "grid h-dvh w-dvw grid-cols-[auto_1fr] overflow-hidden bg-[var(--gray-8)]",
  content: "flex flex-col overflow-auto",
  page: "ml-16 mr-auto flex w-[640px] flex-col pb-6 pt-4",
  title: "mb-3 text-xl font-medium leading-10 text-[var(--gray-1)]",
  subtitle: "mb-2 leading-5 text-[var(--gray-2)]",
  divider: "my-6 h-px bg-[var(--gray-5)]",
};
</script>

<template>
  <div :class="ui.main">
    <SettingsNavBar />

    <div :class="ui.content">
      <div :class="ui.page">
        <!-- Legacy header from the page meta; a migrated page passes its translated title to SettingsPage -->
        <template v-if="route.meta.title">
          <h1 :class="ui.title">{{ route.meta.title }}</h1>
          <h2 :class="ui.subtitle">{{ route.meta.subtitle }}</h2>
          <div :class="ui.divider"></div>
        </template>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
